import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import { LegalSDK } from './LegalSDK';
import { useAuthSDK } from '~/features/auth-sdk';
import SelectLegalAccountPopup from '../ui/SelectLegalAccountPopup.vue';
import AddLegalCompanyPopup from '../ui/AddLegalCompanyPopup.vue';
import type { IAddLegalCompanyRequest } from '~/shared/api/ke-gateway/legal/model';
import { ELocalStorageKeys } from '~/features/store';

let legalSDKInstance: LegalSDK | null = null;

const { authSDKController, onInit, onLogout, onAuth } = useAuthSDK();
if (!legalSDKInstance) {
  legalSDKInstance = new LegalSDK(authSDKController);
}

onInit(async ({ isAuthorized }) => {
  await legalSDKInstance!.init(isAuthorized);
});

onAuth(() => {
  legalSDKInstance!.onAuth();
});

onLogout(() => {
  legalSDKInstance!.onLogout();
});


const isLegalActive = computed(() => legalSDKInstance!.isLegalActive);
const legalCustomerInfo = computed(() => legalSDKInstance!.legalCustomerInfo);
const allLegalCustomers = computed(() => legalSDKInstance!.allLegalCustomers);

// Попап выбора юрлица
const { createPopup } = usePopups();
const selectLegalAccountPopup = createPopup({
  component: SelectLegalAccountPopup,
});

function openSelectLegalAccountPopup() {
  selectLegalAccountPopup.show();
}

function closeSelectLegalAccountPopup() {
  selectLegalAccountPopup.close();
}

// Попап добавления компании
const addCompanyPopup = createPopup({
  component: AddLegalCompanyPopup,
});

function openAddLegalCompanyPopup() {
  addCompanyPopup.show();
}

function closeAddLegalCompanyPopup() {
  addCompanyPopup.close();
}

async function loginAsLegal(legalId?: number) {
  await legalSDKInstance!.loginAsLegal(legalId);

  updateCookie();
}

async function addCompany(request: IAddLegalCompanyRequest) {
  await legalSDKInstance!.addCompany(request);

  updateCookie();
}

function updateCookie() {
  if (isLegalActive.value) {
    document.cookie = 'b2b=true; max-age=31536000; path=/';

    const localStorageKeysMap = {
      [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_ACTIVE_ID]: 'auth_sdk_legal_active_id',
      [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_ACCESS_TOKEN]: 'auth_sdk_legal_access_token',
      [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_REFRESH_TOKEN]: 'auth_sdk_legal_token',
      [ELocalStorageKeys.MM__AUTH_SDK__LEGAL_TOKEN_EXPIRE]: 'auth_sdk_legal_token_exp_time',
      [ELocalStorageKeys.MM__AUTH_SDK__ACCESS_TOKEN]: 'auth_sdk_access_token',
      [ELocalStorageKeys.MM__AUTH_SDK__REFRESH_TOKEN]: 'auth_sdk_token',
      [ELocalStorageKeys.MM__AUTH_SDK__TOKEN_EXPIRE]: 'auth_sdk_token_exp_time',
      [ELocalStorageKeys.MM__AUTH_SDK__MAGNIT_ID_CODE]: 'auth_sdk_magnit_id_code',
    }

    for (const key in localStorageKeysMap) {
      const oldKey = localStorageKeysMap[key as keyof typeof localStorageKeysMap];
      const value = localStorage.getItem(key || '');

      if (key === ELocalStorageKeys.MM__AUTH_SDK__LEGAL_ACTIVE_ID) {
        localStorage.setItem(oldKey, value || '');
      } else {
        localStorage.setItem(oldKey, JSON.stringify(value) || '');
      }
    }
    
    document.cookie = 'b2b=true; max-age=31536000; path=/';
    window.location.reload();
  }
}

export function useLegalSDK() {
  return {
    getLegalCustomers: () => legalSDKInstance!.getLegalCustomers(),
    loginAsLegal,
    getLegalCustomerInfo: (legalId: number) => legalSDKInstance!.getLegalCustomerInfo(legalId),
    logoutAsLegal: () => legalSDKInstance!.logoutAsLegal(),
    addCompany,

    isLegalActive,
    legalCustomerInfo,
    allLegalCustomers,

    openSelectLegalAccountPopup,
    closeSelectLegalAccountPopup,

    openAddLegalCompanyPopup,
    closeAddLegalCompanyPopup,
  };
}
